import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.web.js';
import { IconButton } from '../IconButton/IconButton.web.js';
import { px2rem } from '../utils/helpers/style.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { IconCross } from '../icons/ui_control/IconCross.web.js';
import { useSmartControlledToggle } from '../utils/hooks/useSmartControlledToggle.js';
import { useComponentVariant } from '../utils/hooks/useComponentVariant.js';
import { styles } from '../constants/styles.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';
import { spacing } from '../constants/spacing.js';
import { colors } from '../constants/colors.js';

// TODO: find a way to automatically compute this
var defaultMaxNotificationHeight = px2rem(128);
var Notification = function Notification(_ref) {
  var openedProp = _ref.opened,
      backgroundColor = _ref.backgroundColor,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? colors.snowWhite : _ref$textColor,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      onClose = _ref.onClose,
      children = _ref.children,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? defaultMaxNotificationHeight : _ref$maxHeight,
      icon = _ref.icon,
      id = _ref.id,
      iconButtonProps = _ref.iconButtonProps,
      variantProp = _ref.variant,
      props = _objectWithoutProperties(_ref, ["opened", "backgroundColor", "textColor", "hideCloseButton", "onClose", "children", "maxHeight", "icon", "id", "iconButtonProps", "variant"]);

  var _useSmartControlledTo = useSmartControlledToggle(true, openedProp, onClose),
      _useSmartControlledTo2 = _slicedToArray(_useSmartControlledTo, 2),
      opened = _useSmartControlledTo2[0],
      handleToggle = _useSmartControlledTo2[1];

  var tabIndex = opened ? undefined : -1;
  var theme = useTheme();
  var rawTheme = theme.notification.web;
  var variant = variantProp || theme.variant;
  var notificationTheme = useComponentVariant(rawTheme, variant);
  return /*#__PURE__*/React.createElement(Box, {
    "data-test": "elemental-Notification",
    maxHeight: opened ? maxHeight : 0,
    "data-opened": opened,
    transition: "max-height ".concat(styles.transition.timing.slowest),
    transitionTimingFunction: styles.transition["function"].base,
    overflowY: "hidden",
    id: id
  }, /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    ph: notificationTheme.paddingHorizontal,
    pv: notificationTheme.paddingVertical,
    backgroundColor: backgroundColor ? backgroundColor : theme.colors.primary,
    textColor: textColor
  }, props), icon && renderComponentOrElement(icon, {
    size: 24,
    mr: spacing.xxs
  }), opened ? /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    role: "alert",
    alignItems: "center",
    display: "flex"
  }, children) :
  /*#__PURE__*/

  /**
   * This element needs to be different than that of above, otherwise screen readers won't
   * read the appearing alert.
   */
  React.createElement("span", {
    style: {
      flex: 1
    }
  }, children), !hideCloseButton && /*#__PURE__*/React.createElement(IconButton, _extends({
    icon: IconCross,
    color: backgroundColor ? backgroundColor : theme.colors.primary,
    textColor: textColor,
    onClick: handleToggle,
    tabIndex: tabIndex,
    "data-test": "elemental-Notification-close" // Allow slight overflow into surrounding padding so the icon is in
    // line with content
    ,
    m: "-".concat(spacing.xxxxs) // Don't however let content overlap with the IconButton
    ,
    ml: spacing.xxxs
  }, iconButtonProps))));
};

export { Notification, defaultMaxNotificationHeight };
